<template>
    <div>
        <div style="margin-bottom:20px">
            <el-alert :show-icon="false"
                title="温馨提示，请将加密的报文信息放入以下解密框中进行解密，查看对应的解密数据结构"
                center
                type="error">
            </el-alert>
            <el-button style="margin-top:15px;" type="primary" @click="decode">解密报文</el-button>
            </div>
            <el-form ref="form">
            <el-form-item label="">
                <el-input type="textarea" :rows="5" placeholder="请输入加密字符串信息"  v-model="encodeStr"/>
            </el-form-item>
            <el-form-item label="">
                <json-viewer :value="result" style="border:1px solid black"></json-viewer> 
            </el-form-item>
        </el-form>
        
    </div>
  </template>

  <script>
    import JsonViewer from 'vue-json-viewer'
    import FormComponents from "@/components/form/FormComponents";
    export default {
        name: "DecodeUtils",
        components: {
            FormComponents,
            JsonViewer
        },
        data() {
            return {
                encodeStr:"",
                result:"暂时没有信息"
            }
        },
        methods:{
            decode(){
               if(this.encodeStr==''){
                this.$message({
                    message: '请输入报文内容再进行解密操作',
                    type: 'warning'
                });    
                return
               } 
               let result = spiderHack.decryptJson(this.encodeStr)
               this.result = JSON.parse(result);
            }
        }
    }
  </script>